import AsyncStorage from '@react-native-async-storage/async-storage';
import Moment from 'moment';
import { get } from '..';

interface TicketFilterOptions {
  buildingId: string,
  limit?: number,
  offset?: number,
  other?: boolean,
  low?: boolean,
  moderate?: boolean,
  high?: boolean,
  critical?: boolean,
  done?: boolean,
  inprogress?: boolean,
  reported?: boolean,
  assignee?: string,
  assetId?: string,
  usergroupIds?: string[],
  startTime?: string,
  endTime?: string,
  locationId?: string,
  overdue?: boolean,
  isResponseOverdue?: boolean,
  textSearch?: string,
  templateId?: string,
  templateGroupId?: string,
  issueId?: string,
  sortField?: 'createdOn' | 'priority',
  sortOrder?: 'asc' | 'desc',
}

const getTickets = async ({
  buildingId,
  limit,
  offset,
  other,
  low,
  moderate,
  high,
  critical,
  done,
  inprogress,
  reported,
  assignee,
  assetId,
  usergroupIds,
  startTime,
  endTime,
  locationId,
  overdue,
  isResponseOverdue,
  textSearch,
  templateId,
  templateGroupId,
  issueId,
  sortField,
  sortOrder,
}: TicketFilterOptions) => {
  try {
    const jwtToken = await AsyncStorage.getItem('token');

    if (!jwtToken || !buildingId) {
      return null;
    }

    const noPriorityFilter = !other && !low && !moderate && !high && !critical;

    const noStatusFilter = !done && !inprogress && !reported;

    let query = 'assets/tickets';

    query += `?buildingId=${buildingId}&limit=${limit ?? 100}`;

    if (offset) query += `&offset=${offset}`;

    if (!noPriorityFilter) {
      if (other) {
        query += '&priority=4';
      }
      if (low) {
        query += '&priority=3';
      }
      if (moderate) {
        query += '&priority=2';
      }
      if (high) {
        query += '&priority=1';
      }
      if (critical) {
        query += '&priority=0';
      }
    }

    if (!noStatusFilter) {
      if (done) {
        query += '&status=completed';
      }
      if (inprogress) {
        query += '&status=inprogress';
      }
      if (reported) {
        query += '&status=reported';
      }
    }

    if (assignee?.length > 0) {
      query += `&assignee=${encodeURIComponent(assignee)}`;
    }

    if (assetId?.length > 0) {
      query += `&assetId=${assetId}`;
    }

    if (usergroupIds?.length > 0) {
      usergroupIds.forEach((id) => {
        if (id) {
          query += `&userGroupId=${id}`;
        }
      });
    }

    query += `&createdOnFrom=${Moment(startTime ?? new Date(0)).format('YYYY-MM-DDTHH:mm:ss')}`;

    query += `&createdOnTo=${Moment(endTime ?? Moment()).endOf('day').format('YYYY-MM-DDTHH:mm:ss')}`;

    if (locationId) {
      query += `&locationId=${locationId}`;
    }

    if (overdue) {
      query += `&isOverdue=${overdue}`;
    }

    if (isResponseOverdue) {
      query += `&isResponseOverdue=${isResponseOverdue}`;
    }

    if (textSearch) {
      query += `&textSearch=${textSearch}`;
    }

    if (templateId) {
      query += `&templateId=${templateId}`;
    } else if (templateGroupId) {
      query += `&templateGroupId=${templateGroupId}`;
    }

    if (issueId) {
      query += `&issueId=${issueId}`;
    }

    if (sortField) {
      query += `&sortField=${sortField}`;
      if (sortOrder) {
        query += `&sortOrder=${sortOrder}`;
      } else {
        query += '&sortOrder=asc';
      }
    }

    return get(query);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
    return null;
  }
};

export default getTickets;
